import Rewards from "./list";

export default Rewards;
